import { IngredientData } from '../data/ingredientDatabase';

const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Fetch the full ingredient catalog from the backend. Loaded once on app
 * startup and cached in-process (see data/ingredientDatabase + the
 * IngredientCatalogLoader in App.tsx), replacing the old bundled static list.
 */
export const fetchIngredientCatalog = async (
  token: string
): Promise<IngredientData[]> => {
  const response = await fetch(`${API_BASE_URL}/api/ingredients`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    throw new Error(
      `Failed to load ingredient catalog: ${response.status}`
    );
  }
  const data = await response.json();
  return data.ingredients ?? [];
};
